exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-row[data-v-1410c3ad] {\n  margin-bottom: 20px;\n}\n.header-row .search-fabric[data-v-1410c3ad] {\n  height: 38px;\n}", ""]);

// exports
